module.exports = __webpack_public_path__ + "c4a29cdcbaaeca28378ac33160da34df.ogg";